// import React, { useState, useEffect, useRef } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import {
//   Send,
//   Search,
//   MoreVertical,
//   Paperclip,
//   Smile,
//   Phone,
//   Video,
//   Info,
//   ArrowLeft,
//   Pin,
//   Forward,
//   Trash2,
//   Check,
//   CheckCheck,
//   Clock,
//   Online,
//   MessageSquare,
//   Users,
//   X,
//   Plus
// } from 'lucide-react'
// import EmojiPicker from 'emoji-picker-react'
// import {
//   sendMessageThunk,
//   getConversationsThunk,
//   getConversationMessagesThunk,
//   searchMessagesThunk,
//   pinMessageThunk,
//   forwardMessageThunk,
//   deleteMessageThunk,
//   getUserPresenceThunk,
//   setCurrentConversation,
//   clearSearchResults,
//   clearError,
//   addMessageToConversation,
//   updateMessageStatus,
//   addTempConversation,
//   markConversationRead
// } from '../store/API/messageSlice'
// import { fetchAllUsers, checkActiveUser } from '../store/slices/authSlice'
// import {
//   initSocket,
//   emitJoinConversation,
//   emitLeaveConversation,
//   emitMarkAsRead,
//   emitTyping,
//   isSocketConnected
// } from '../socket'

// // Main App Component
// const MessagingApp = () => {
//   const dispatch = useDispatch()
//   const {
//     conversations,
//     conversationMessages,
//     searchResults,
//     userPresence,
//     loading,
//     error,
//     currentConversationId,
//     pagination
//   } = useSelector(state => state.messages)

//   const { user, activeUser } = useSelector(state => state.auth)

//   const currentUserId =
//     activeUser?._id || activeUser?.id || user?._id || user?.id

//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
//   const [showConversations, setShowConversations] = useState(true)
//   const [searchQuery, setSearchQuery] = useState('')
//   const [showSearch, setShowSearch] = useState(false)
//   const [showAddUserModal, setShowAddUserModal] = useState(false)
//   const [isTyping, setIsTyping] = useState(false)
//   const typingTimeoutRef = useRef(null)

//   // Initialize socket connection
//   useEffect(() => {
//     // Initialize socket if not already connected
//     if (!isSocketConnected()) {
//       initSocket()
//     }

//     // Cleanup function
//     return () => {
//       if (currentConversationId) {
//         emitLeaveConversation(currentConversationId)
//       }
//     }
//   }, [])

//   useEffect(() => {
//     if (!activeUser && user) {
//       dispatch(checkActiveUser())
//     }
//   }, [dispatch, activeUser, user])

//   useEffect(() => {
//     const handleNewMessage = data => {
//       console.log('New message received:', data)
//       if (data && data.data && data.conversationId) {
//         dispatch(
//           addMessageToConversation({
//             conversationId: data.conversationId,
//             message: data.data
//           })
//         )
//         if (data.conversationId === currentConversationId) {
//           emitMarkAsRead(data.conversationId)
//         }
//         dispatch(getConversationsThunk())
//       }
//     }

//     const handleConversationRead = data => {
//       dispatch(markConversationRead(data))
//       dispatch(getConversationsThunk())
//     }

//     // Add event listeners
//     window.addEventListener('newMessage', e => handleNewMessage(e.detail))
//     window.addEventListener('conversationRead', e =>
//       handleConversationRead(e.detail)
//     )

//     return () => {
//       window.removeEventListener('newMessage', e => handleNewMessage(e.detail))
//       window.removeEventListener('conversationRead', e =>
//         handleConversationRead(e.detail)
//       )
//     }
//   }, [dispatch, currentConversationId])

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768)
//     }

//     window.addEventListener('resize', handleResize)
//     return () => window.removeEventListener('resize', handleResize)
//   }, [])

//   useEffect(() => {
//     dispatch(getConversationsThunk())
//   }, [dispatch])

//   useEffect(() => {
//     if (currentConversationId) {
//       emitJoinConversation(currentConversationId)
//       emitMarkAsRead(currentConversationId)
//     }

//     return () => {
//       if (currentConversationId) {
//         emitLeaveConversation(currentConversationId)
//       }
//     }
//   }, [currentConversationId])

//   const handleConversationSelect = conversationId => {
//     if (!conversationId) return

//     dispatch(setCurrentConversation(conversationId))
//     dispatch(getConversationMessagesThunk({ conversationId }))
//     // Mark conversation as read in local state
//     dispatch(
//       markConversationRead({
//         conversationId,
//         userId: currentUserId,
//         unreadCount: 0
//       })
//     )
//     // Emit socket event to mark as read
//     emitMarkAsRead(conversationId)

//     if (isMobile) {
//       setShowConversations(false)
//     }
//   }

//   const handleBackToConversations = () => {
//     setShowConversations(true)
//     dispatch(setCurrentConversation(null))
//   }

//   const handleSearch = query => {
//     if (query.trim()) {
//       dispatch(searchMessagesThunk({ query }))
//       setShowSearch(true)
//     } else {
//       dispatch(clearSearchResults())
//       setShowSearch(false)
//     }
//   }
//   const handleAddUser = async selectedUser => {
//     try {
//       // Check if conversation already exists
//       const existingConversation = conversations.find(
//         conv =>
//           conv.conversationType === 'direct' &&
//           conv.participants.some(
//             participant => participant._id === selectedUser._id
//           )
//       )

//       if (existingConversation) {
//         // If conversation exists, just select it
//         handleConversationSelect(existingConversation._id)
//       } else {
//         // Create a temporary conversation for UI
//         const tempConversation = {
//           _id: `temp_${Date.now()}_${selectedUser._id}`,
//           participants: [selectedUser],
//           conversationType: 'direct',
//           lastMessage: null,
//           lastActivity: new Date(),
//           unreadCount: 0
//         }

//         // Add temp conversation to state
//         dispatch(addTempConversation(tempConversation))

//         // Select the temp conversation
//         handleConversationSelect(tempConversation._id)
//       }

//       setShowAddUserModal(false)
//     } catch (error) {
//       console.error('Failed to add user:', error)
//     }
//   }
//   return (
//     <div className='h-[86vh] bg-gradient-to-br from-slate-900/95 via-slate-950/95 to-slate-900/95 text-teal-300 flex'>
//       {/* Sidebar - Conversations */}
//       <div
//         className={`${isMobile ? (showConversations ? 'w-full' : 'hidden') : 'w-1/4'
//           } bg-slate-800/50 border-r border-slate-700/50 flex flex-col backdrop-blur-sm`}
//       >
//         {/* Header */}
//         <div className='p-4 border-b border-slate-700/50'>
//           <div className='flex items-center justify-between mb-4'>
//             <h1 className='text-xl font-semibold text-teal-300'>Messages</h1>
//             <button
//               onClick={() => setShowAddUserModal(true)}
//               className='p-2 hover:bg-slate-700/50 rounded-lg transition-colors'
//             >
//               <Plus className='w-5 h-5' />
//             </button>
//           </div>

//           {/* Search */}
//           <div className='relative'>
//             <Search className='absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400' />
//             <input
//               type='text'
//               placeholder='Search conversations...'
//               value={searchQuery}
//               onChange={e => {
//                 setSearchQuery(e.target.value)
//                 handleSearch(e.target.value)
//               }}
//               className='w-full pl-10 pr-4 py-2 bg-slate-700/50 border border-slate-600/50 rounded-lg text-teal-300 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500/50 focus:border-transparent'
//             />
//           </div>
//         </div>

//         {/* Conversations List */}
//         <div className='flex-1 overflow-y-auto'>
//           {showSearch && searchResults.length > 0 ? (
//             <SearchResults
//               results={searchResults}
//               onResultClick={conversationId => {
//                 handleConversationSelect(conversationId)
//                 setShowSearch(false)
//                 setSearchQuery('')
//                 dispatch(clearSearchResults())
//               }}
//             />
//           ) : (
//             <ConversationsList
//               conversations={conversations}
//               currentConversationId={currentConversationId}
//               onConversationSelect={handleConversationSelect}
//               loading={loading.getConversations}
//               userPresence={userPresence}
//             />
//           )}
//         </div>
//       </div>

//       {/* Main Chat Area */}
//       <div
//         className={`${isMobile ? (showConversations ? 'hidden' : 'w-full') : 'flex-1'
//           } flex flex-col bg-slate-900/30`}
//       >
//         {currentConversationId ? (
//           <ChatWindow
//             conversationId={currentConversationId}
//             messages={
//               conversationMessages[currentConversationId]?.messages || []
//             }
//             loading={loading}
//             error={error}
//             onBack={isMobile ? handleBackToConversations : undefined}
//             userPresence={userPresence}
//           />
//         ) : (
//           <EmptyState />
//         )}
//       </div>
//       <AddUserModal
//         show={showAddUserModal}
//         onClose={() => setShowAddUserModal(false)}
//         onAddUser={handleAddUser}
//       />
//     </div>
//   )
// }

// // Conversations List Component
// const ConversationsList = ({
//   conversations,
//   currentConversationId,
//   onConversationSelect,
//   loading,
//   userPresence,
//   pagination
// }) => {
//   const dispatch = useDispatch()

//   const loadMoreConversations = () => {
//     const nextPage = pagination?.conversations?.page + 1
//     if (pagination?.conversations?.hasMore) {
//       dispatch(getConversationsThunk({ page: nextPage }))
//     }
//   }

//   if (loading && conversations.length === 0) {
//     return (
//       <div className='flex items-center justify-center h-64'>
//         <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-teal-300'></div>
//       </div>
//     )
//   }

//   return (
//     <div className='space-y-1 p-2'>
//       {conversations.map(conversation => (
//         <ConversationItem
//           key={conversation._id}
//           conversation={conversation}
//           isActive={conversation._id === currentConversationId}
//           onClick={() => onConversationSelect(conversation._id)}
//           userPresence={userPresence}
//         />
//       ))}

//       {pagination?.conversations?.hasMore && (
//         <button
//           onClick={loadMoreConversations}
//           disabled={loading}
//           className='w-full py-2 text-sm text-slate-400 hover:text-teal-300 transition-colors'
//         >
//           {loading ? 'Loading...' : 'Load More'}
//         </button>
//       )}
//     </div>
//   )
// }

// // Individual Conversation Item
// const ConversationItem = ({
//   conversation,
//   isActive,
//   onClick,
//   userPresence
// }) => {
//   const { user, activeUser } = useSelector(state => state.auth)
//   const currentUserId =
//     activeUser?._id || activeUser?.id || user?._id || user?.id

//   const getConversationName = () => {
//     if (conversation.conversationType === 'group') {
//       return conversation.group?.name || 'Group Chat'
//     } else {
//       return conversation.participants[0]?.username || 'Unknown User'
//     }
//   }

//   const getLastMessagePreview = () => {
//     if (!conversation.lastMessage) return 'No messages yet'

//     const content = conversation.lastMessage.content
//     if (conversation.lastMessage.messageType === 'file') {
//       return '📎 File attachment'
//     } else if (conversation.lastMessage.messageType === 'image') {
//       return '🖼️ Image'
//     } else if (conversation.lastMessage.messageType === 'forward') {
//       return '↩️ Forwarded message'
//     }
//     return content?.substring(0, 50) + (content?.length > 50 ? '...' : '')
//   }

//   const getLastMessageTime = () => {
//     if (!conversation.lastMessage?.sentAt) return ''

//     const date = new Date(conversation.lastMessage.sentAt)
//     const now = new Date()
//     const diffInHours = (now - date) / (1000 * 60 * 60)

//     if (diffInHours < 24) {
//       return date.toLocaleTimeString([], {
//         hour: '2-digit',
//         minute: '2-digit'
//       })
//     } else {
//       return date.toLocaleDateString()
//     }
//   }

//   const isUserOnline = () => {
//     if (conversation.conversationType === 'group') return false
//     const userId = conversation.participants[0]?._id
//     return userPresence[userId]?.isOnline || false
//   }

//   const getUnreadCount = () => {
//     if (typeof conversation.unreadCount === 'number') {
//       return conversation.unreadCount
//     }
//     if (Array.isArray(conversation.unreadCount)) {
//       const unreadEntry = conversation.unreadCount.find(
//         u => u.user.toString() === currentUserId
//       )
//       return unreadEntry ? unreadEntry.count : 0
//     }
//     return 0
//   }

//   return (
//     <div
//       onClick={onClick}
//       className={`flex items-center p-3 rounded-lg cursor-pointer transition-colors ${isActive
//         ? 'bg-teal-600/20 border-l-4 border-teal-400'
//         : 'hover:bg-slate-700/30'
//         }`}
//     >
//       {/* Avatar */}
//       <div className='relative'>
//         <div className='w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center text-white font-semibold'>
//           {conversation.conversationType === 'group' ? (
//             <Users className='w-6 h-6' />
//           ) : (
//             getConversationName().charAt(0).toUpperCase()
//           )}
//         </div>
//         {isUserOnline() && (
//           <div className='absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-slate-800 rounded-full'></div>
//         )}
//       </div>

//       {/* Content */}
//       <div className='ml-3 flex-1 min-w-0'>
//         <div className='flex items-center justify-between'>
//           <h3 className='font-semibold text-teal-300 truncate'>
//             {getConversationName()}
//           </h3>
//           <span className='text-xs text-slate-400'>{getLastMessageTime()}</span>
//         </div>

//         <div className='flex items-center justify-between mt-1'>
//           <p className='text-sm text-slate-400 truncate'>
//             {getLastMessagePreview()}
//           </p>
//           {getUnreadCount() > 0 && (
//             <span className='ml-2 px-2 py-1 bg-teal-500 text-white text-xs rounded-full min-w-[20px] text-center'>
//               {getUnreadCount()}
//             </span>
//           )}
//         </div>
//       </div>
//     </div>
//   )
// }

// // Add User Modal Component
// const AddUserModal = ({ show, onClose, onAddUser }) => {
//   const dispatch = useDispatch()
//   const { users, status } = useSelector(state => state.auth)
//   const [searchTerm, setSearchTerm] = useState('')

//   useEffect(() => {
//     if (show && (!users || users.length === 0)) {
//       dispatch(fetchAllUsers())
//     }
//   }, [show, users, dispatch])

//   const filteredUsers =
//     users?.filter(
//       user =>
//         user.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         user.email?.toLowerCase().includes(searchTerm.toLowerCase())
//     ) || []

//   if (!show) return null

//   return (
//     <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50'>
//       <div className='bg-slate-800 rounded-lg p-6 w-96 max-h-96'>
//         <div className='flex items-center justify-between mb-4'>
//           <h3 className='font-semibold text-teal-300'>Add User to Chat</h3>
//           <button onClick={onClose} className='p-1 hover:bg-slate-700 rounded'>
//             <X className='w-4 h-4' />
//           </button>
//         </div>

//         {/* Search Input */}
//         <div className='relative mb-4'>
//           <Search className='absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400' />
//           <input
//             type='text'
//             placeholder='Search users...'
//             value={searchTerm}
//             onChange={e => setSearchTerm(e.target.value)}
//             className='w-full pl-10 pr-4 py-2 bg-slate-700/50 border border-slate-600/50 rounded-lg text-teal-300 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500/50'
//           />
//         </div>

//         {/* Users List */}
//         <div className='max-h-64 overflow-y-auto space-y-2'>
//           {status === 'loading' ? (
//             <div className='flex items-center justify-center py-4'>
//               <div className='animate-spin rounded-full h-6 w-6 border-b-2 border-teal-300'></div>
//             </div>
//           ) : (
//             filteredUsers.map(user => (
//               <div
//                 key={user._id}
//                 onClick={() => onAddUser(user)}
//                 className='flex items-center space-x-3 p-2 hover:bg-slate-700/30 rounded-lg cursor-pointer'
//               >
//                 <div className='w-8 h-8 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center text-white font-semibold text-sm'>
//                   {user.username?.charAt(0).toUpperCase()}
//                 </div>
//                 <div>
//                   <p className='text-sm font-medium text-teal-300'>
//                     {user.username}
//                   </p>
//                   <p className='text-xs text-slate-400'>{user.email}</p>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     </div>
//   )
// }

// // Chat Window Component
// const ChatWindow = ({
//   conversationId,
//   messages,
//   loading,
//   error,
//   onBack,
//   userPresence
// }) => {
//   const dispatch = useDispatch()
//   const [messageInput, setMessageInput] = useState('')
//   const [selectedMessage, setSelectedMessage] = useState(null)
//   const [showMessageActions, setShowMessageActions] = useState(false)
//   const [isTyping, setIsTyping] = useState(false)
//   const messagesEndRef = useRef(null)
//   const fileInputRef = useRef(null)
//   const typingTimeoutRef = useRef(null)
//   const [fileUploadError, setFileUploadError] = useState(null)
//   const [isUploadingFile, setIsUploadingFile] = useState(false)
//   const [selectedFiles, setSelectedFiles] = useState([])
//   const [showEmojiPicker, setShowEmojiPicker] = useState(false)
//   const [uploadType, setUploadType] = useState(null)

//   const currentConversation = useSelector(state =>
//     state.messages.conversations.find(conv => conv._id === conversationId)
//   )

//   useEffect(() => {
//     scrollToBottom()
//   }, [messages])

//   useEffect(() => {
//     if (conversationId && currentConversation?.participants?.length > 0) {
//       currentConversation.participants.forEach(participant => {
//         if (participant._id) {
//           dispatch(getUserPresenceThunk(participant._id)).catch(error => {
//             console.log(`User ${participant._id} appears to be offline`)
//           })
//         }
//       })
//     }
//   }, [conversationId, currentConversation, dispatch])

//   useEffect(() => {
//     const handleTypingEvent = event => {
//       const {
//         conversationId: typingConversationId,
//         userId,
//         isTyping: userIsTyping
//       } = event.detail
//       if (typingConversationId === conversationId) {
//         console.log(
//           `User ${userId} is ${userIsTyping ? 'typing' : 'not typing'}`
//         )
//       }
//     }

//     window.addEventListener('userTyping', handleTypingEvent)
//     return () => window.removeEventListener('userTyping', handleTypingEvent)
//   }, [conversationId])

//   const scrollToBottom = () => {
//     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
//   }

//   const handleFileUpload = (event, type) => {
//     const files = Array.from(event.target.files)
//     if (files.length === 0) return

//     const maxFileSize = 10 * 1024 * 1024 // 10MB

//     // Remove restrictive file type checking for non-image uploads
//     const invalidFiles = files.filter(file => {
//       if (file.size > maxFileSize) return true;

//       // Only check image types if specifically uploading as image
//       if (type === 'image') {
//         const allowedImageTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];
//         return !allowedImageTypes.includes(file.type);
//       }

//       return false; // Allow all other file types
//     })

//     if (invalidFiles.length > 0) {
//       const sizeIssues = invalidFiles.filter(f => f.size > maxFileSize);
//       const typeIssues = invalidFiles.filter(f => f.size <= maxFileSize);

//       let errorMessage = '';
//       if (sizeIssues.length > 0) {
//         errorMessage += `Files too large (max 10MB): ${sizeIssues.map(f => f.name).join(', ')}. `;
//       }
//       if (typeIssues.length > 0 && type === 'image') {
//         errorMessage += `Invalid image files: ${typeIssues.map(f => f.name).join(', ')}.`;
//       }

//       setFileUploadError(errorMessage);
//       return
//     }

//     setSelectedFiles(files)
//     setUploadType(type)
//     setFileUploadError(null)
//   }

//   const handleSendMessage = async () => {
//     if (!messageInput.trim() && selectedFiles.length === 0) return

//     if (isTyping) {
//       emitTyping(
//         conversationId,
//         currentConversation.participants[0]?._id,
//         false
//       )
//       setIsTyping(false)
//     }

//     try {
//       let messageData;

//       if (selectedFiles.length > 0) {
//         setIsUploadingFile(true)
//         setFileUploadError(null)

//         // Create FormData
//         const formData = new FormData()

//         // Add files first
//         selectedFiles.forEach(file => {
//           formData.append('attachments', file)
//           console.log('📎 Added file:', file.name, file.type, file.size);
//         })

//         // Add content if exists
//         if (messageInput.trim()) {
//           formData.append('content', messageInput)
//         }

//         // Determine message type
//         const isImage = selectedFiles.every(file =>
//           ['image/png', 'image/jpeg', 'image/gif', 'image/webp'].includes(file.type)
//         )
//         formData.append('messageType', isImage ? 'image' : 'file')

//         // Add receiver/group info
//         if (currentConversation?.conversationType === 'group') {
//           formData.append('groupId', currentConversation.group._id)
//           console.log('📤 Adding groupId:', currentConversation.group._id);
//         } else {
//           // Get receiverId - handle temp conversations
//           let receiverId;
//           if (conversationId.startsWith('temp_')) {
//             receiverId = currentConversation?.participants?.[0]?._id
//           } else {
//             receiverId = currentConversation?.participants?.[0]?._id
//           }

//           if (!receiverId) {
//             setFileUploadError('No valid receiver found')
//             setIsUploadingFile(false)
//             return
//           }

//           formData.append('receiverId', receiverId)
//           console.log('📤 Adding receiverId:', receiverId);
//         }

//         // Log FormData contents for debugging
//         console.log('📋 FormData contents:');
//         for (let [key, value] of formData.entries()) {
//           console.log(`  ${key}:`, value instanceof File ? `${value.name} (${value.type})` : value);
//         }

//         messageData = formData;
//       } else {
//         // Text message
//         messageData = {
//           content: messageInput,
//           messageType: 'text'
//         }

//         if (currentConversation?.conversationType === 'group') {
//           messageData.groupId = currentConversation.group._id
//         } else {
//           let receiverId;
//           if (conversationId.startsWith('temp_')) {
//             receiverId = currentConversation?.participants?.[0]?._id
//           } else {
//             receiverId = currentConversation?.participants?.[0]?._id
//           }

//           if (!receiverId) {
//             throw new Error('No valid receiver found')
//           }
//           messageData.receiverId = receiverId
//         }
//       }

//       console.log('🚀 Dispatching message:', messageData);
//       await dispatch(sendMessageThunk(messageData)).unwrap()

//       // Clear form
//       setSelectedFiles([])
//       if (fileInputRef.current) {
//         fileInputRef.current.value = ''
//       }
//       setMessageInput('')
//       scrollToBottom()

//     } catch (error) {
//       console.error('Failed to send message:', error)
//       if (selectedFiles.length > 0) {
//         setFileUploadError(error.message || 'Failed to send message with files')
//       }
//     } finally {
//       if (selectedFiles.length > 0) {
//         setIsUploadingFile(false)
//       }
//     }
//   }

//   const removeSelectedFile = indexToRemove => {
//     setSelectedFiles(prev => prev.filter((_, index) => index !== indexToRemove))
//     if (fileInputRef.current) {
//       fileInputRef.current.value = ''
//     }
//   }

//   const handleMessageAction = (action, messageId) => {
//     switch (action) {
//       case 'pin':
//         dispatch(pinMessageThunk({ messageId, pin: true }))
//         break
//       case 'unpin':
//         dispatch(pinMessageThunk({ messageId, pin: false }))
//         break
//       case 'delete':
//         dispatch(deleteMessageThunk(messageId))
//         break
//       case 'forward':
//         // TODO: Implement forward modal
//         break
//       default:
//         break
//     }
//     setShowMessageActions(false)
//     setSelectedMessage(null)
//   }

//   const getConversationTitle = () => {
//     if (!currentConversation) return 'Loading...'

//     if (currentConversation.conversationType === 'group') {
//       return currentConversation.group?.name || 'Group Chat'
//     } else {
//       const participant = currentConversation.participants?.[0]
//       return participant?.username || 'Unknown User'
//     }
//   }

//   const isUserOnline = () => {
//     if (
//       !currentConversation ||
//       currentConversation.conversationType === 'group'
//     )
//       return false
//     const userId = currentConversation.participants[0]?._id
//     return userPresence[userId]?.isOnline || false
//   }

//   const handleEmojiClick = emojiObject => {
//     setMessageInput(prev => prev + emojiObject.emoji)
//     setShowEmojiPicker(false)
//   }

//   return (
//     <div className='flex flex-col h-full'>
//       {/* Chat Header */}
//       <div className='p-4 border-b border-slate-700/50 bg-slate-800/30 backdrop-blur-sm'>
//         <div className='flex items-center justify-between'>
//           <div className='flex items-center space-x-3'>
//             {onBack && (
//               <button
//                 onClick={onBack}
//                 className='p-2 hover:bg-slate-700/50 rounded-lg transition-colors'
//               >
//                 <ArrowLeft className='w-5 h-5' />
//               </button>
//             )}

//             <div className='relative'>
//               <div className='w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center text-white font-semibold'>
//                 {currentConversation?.conversationType === 'group' ? (
//                   <Users className='w-5 h-5' />
//                 ) : (
//                   getConversationTitle().charAt(0).toUpperCase()
//                 )}
//               </div>
//               {isUserOnline() && (
//                 <div className='absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 border-2 border-slate-800 rounded-full'></div>
//               )}
//             </div>

//             <div>
//               <h2 className='font-semibold text-teal-300'>
//                 {getConversationTitle()}
//               </h2>
//               {currentConversation?.conversationType !== 'group' && (
//                 <p className={`text-xs ${isUserOnline() ? 'text-green-400' : 'text-slate-400'}`}>
//                   {isUserOnline() ? 'Online' : 'Offline'}
//                 </p>
//               )}
//             </div>
//           </div>

//           <div className='flex items-center space-x-2'>
//             <button className='p-2 hover:bg-slate-700/50 rounded-lg transition-colors'>
//               <Phone className='w-5 h-5' />
//             </button>
//             <button className='p-2 hover:bg-slate-700/50 rounded-lg transition-colors'>
//               <Video className='w-5 h-5' />
//             </button>
//             <button className='p-2 hover:bg-slate-700/50 rounded-lg transition-colors'>
//               <Info className='w-5 h-5' />
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Messages Area */}
//       <div className='flex-1 overflow-y-auto p-4 space-y-4'>
//         {loading.getConversationMessages && messages.length === 0 ? (
//           <div className='flex items-center justify-center h-full'>
//             <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-teal-300'></div>
//           </div>
//         ) : (
//           <>
//             {messages.map(message => (
//               <MessageItem
//                 key={message._id}
//                 message={message}
//                 onMessageSelect={setSelectedMessage}
//                 onShowActions={setShowMessageActions}
//               />
//             ))}
//             <div ref={messagesEndRef} />
//           </>
//         )}
//       </div>

//       {/* Message Input */}
//       <div className='p-4 border-t border-slate-700/50 bg-slate-800/30 backdrop-blur-sm'>
//         {/* File Upload Error */}
//         {fileUploadError && (
//           <div className='mb-2 p-2 bg-red-500/20 border border-red-500/50 rounded text-red-300 text-sm'>
//             {fileUploadError}
//             <button
//               onClick={() => setFileUploadError(null)}
//               className='ml-2 text-red-400 hover:text-red-300'
//             >
//               ×
//             </button>
//           </div>
//         )}

//         {/* Selected Files Preview */}
//         {selectedFiles.length > 0 && (
//           <div className='mb-3 p-3 bg-slate-700/30 border border-slate-600/50 rounded-lg'>
//             <div className='flex items-center justify-between mb-2'>
//               <span className='text-sm text-slate-300'>Selected Files:</span>
//               <button
//                 onClick={() => setSelectedFiles([])}
//                 className='text-slate-400 hover:text-slate-200 text-sm'
//               >
//                 Clear All
//               </button>
//             </div>
//             <div className='space-y-2'>
//               {selectedFiles.map((file, index) => (
//                 <div
//                   key={index}
//                   className='flex items-center justify-between bg-slate-600/30 p-2 rounded'
//                 >
//                   <div className='flex items-center space-x-2'>
//                     <Paperclip className='w-4 h-4 text-teal-400' />
//                     <span className='text-sm text-slate-200'>{file.name}</span>
//                     <span className='text-xs text-slate-400'>
//                       ({(file.size / 1024 / 1024).toFixed(2)} MB)
//                     </span>
//                   </div>
//                   <button
//                     onClick={() => removeSelectedFile(index)}
//                     className='text-red-400 hover:text-red-300 p-1'
//                   >
//                     <X className='w-4 h-4' />
//                   </button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         <div className='flex items-end space-x-2 relative'>
//           <input
//             type='file'
//             ref={fileInputRef}
//             onChange={handleFileUpload}
//             multiple
//             className='hidden'
//             accept='*/*'
//           />
//           <button
//             onClick={() => fileInputRef.current?.click()}
//             disabled={isUploadingFile}
//             className={`p-2 hover:bg-slate-700/50 rounded-lg transition-colors ${isUploadingFile ? 'opacity-50 cursor-not-allowed' : ''
//               }`}
//           >
//             {isUploadingFile ? (
//               <div className='animate-spin rounded-full h-5 w-5 border-b-2 border-teal-300'></div>
//             ) : (
//               <Paperclip className='w-5 h-5' />
//             )}
//           </button>

//           <button
//             onClick={() => setShowEmojiPicker(!showEmojiPicker)}
//             className='p-2 hover:bg-slate-700/50 rounded-lg transition-colors'
//           >
//             <Smile className='w-5 h-5' />
//           </button>

//           {showEmojiPicker && (
//             <div className='absolute bottom-14 left-2 z-10'>
//               <EmojiPicker onEmojiClick={handleEmojiClick} />
//             </div>
//           )}

//           <div className='flex-1 max-h-32 overflow-y-auto'>
//             <textarea
//               value={messageInput}
//               onChange={e => {
//                 setMessageInput(e.target.value)

//                 if (currentConversation?.participants?.length > 0) {
//                   const recipientId =
//                     currentConversation.conversationType === 'group'
//                       ? currentConversation.group?._id
//                       : currentConversation.participants[0]?._id

//                   if (!isTyping) {
//                     setIsTyping(true)
//                     emitTyping(conversationId, recipientId, true)
//                   }

//                   if (typingTimeoutRef.current) {
//                     clearTimeout(typingTimeoutRef.current)
//                   }

//                   typingTimeoutRef.current = setTimeout(() => {
//                     setIsTyping(false)
//                     emitTyping(conversationId, recipientId, false)
//                   }, 2000)
//                 }
//               }}
//               onKeyPress={e => {
//                 if (e.key === 'Enter' && !e.shiftKey) {
//                   e.preventDefault()
//                   handleSendMessage()
//                 }
//               }}
//               placeholder='Type a message...'
//               className='w-full px-4 py-2 mt-2 bg-slate-700/50 border border-slate-600/50 rounded-lg text-teal-300 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500/50 focus:border-transparent resize-none'
//               rows='1'
//             />
//           </div>

//           <button
//             onClick={handleSendMessage}
//             disabled={
//               (!messageInput.trim() && selectedFiles.length === 0) ||
//               loading.sendMessage
//             }
//             className='p-2 bg-teal-600 hover:bg-teal-700 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg transition-colors'
//           >
//             <Send className='w-5 h-5 text-white' />
//           </button>
//         </div>
//       </div>

//       {/* Message Actions Modal */}
//       {showMessageActions && selectedMessage && (
//         <MessageActionsModal
//           message={selectedMessage}
//           onAction={handleMessageAction}
//           onClose={() => {
//             setShowMessageActions(false)
//             setSelectedMessage(null)
//           }}
//         />
//       )}
//     </div>
//   )
// }

// const MessageItem = ({ message, onMessageSelect, onShowActions }) => {
//   const { user, activeUser } = useSelector(state => state.auth)
//   const [isLoading, setIsLoading] = useState(true)
//   const currentUserId =
//     activeUser?._id || activeUser?.id || user?._id || user?.id
//   const senderId =
//     message?.sender?._id || message?.sender?.id || message?.sender

//   const isOwn = currentUserId && senderId && currentUserId === senderId
//   const messageAlignment = isOwn ? 'justify-end' : 'justify-start'
//   const messageStyle = isOwn
//     ? 'bg-teal-600 text-white'
//     : 'bg-slate-700/50 text-teal-300'

//   // Base URL for your backend
//   const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000'

//   const getMessageStatus = () => {
//     if (message.readBy?.length > 0) {
//       return <CheckCheck className='w-4 h-4 text-blue-400' />
//     } else if (message.deliveredTo?.length > 0) {
//       return <CheckCheck className='w-4 h-4 text-slate-400' />
//     } else {
//       return <Check className='w-4 h-4 text-slate-400' />
//     }
//   }

//   const formatTime = timestamp => {
//     return new Date(timestamp).toLocaleTimeString([], {
//       hour: '2-digit',
//       minute: '2-digit'
//     })
//   }

//   const handleLongPress = () => {
//     onMessageSelect?.(message)
//     onShowActions?.(true)
//   }

//   const handleOpenFile = attachment => {
//     const fileUrl = attachment.filePath.startsWith('http')
//       ? attachment.filePath
//       : `${BASE_URL}${attachment.filePath}`
//     window.open(fileUrl, '_blank')
//   }

//   const handleDownloadFile = attachment => {
//     const fileUrl = attachment.filePath.startsWith('http')
//       ? attachment.filePath
//       : `${BASE_URL}${attachment.filePath}`
//     const link = document.createElement('a')
//     link.href = fileUrl
//     link.download = attachment.originalName || 'download'
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//   }

//   return (
//     <div className={`flex ${messageAlignment} group mb-4`}>
//       <div
//         className={`max-w-xs lg:max-w-md px-4 py-2 rounded-lg relative ${messageStyle}`}
//         onContextMenu={e => {
//           e.preventDefault()
//           handleLongPress()
//         }}
//       >
//         {!isOwn && message.sender && (
//           <div className='text-xs text-slate-400 mb-1'>
//             {message.sender.username || 'Unknown User'}
//           </div>
//         )}

//         {message.messageType === 'forward' && (
//           <div className='text-xs text-slate-400 mb-1 italic'>↩️ Forwarded</div>
//         )}

//         {message.isPinned && (
//           <div className='text-xs text-yellow-400 mb-1'>📌</div>
//         )}

//         <div className='mb-1'>
//           {message.messageType === 'text' && (
//             <p className='whitespace-pre-wrap break-words'>{message.content}</p>
//           )}

//           {message.messageType === 'image' && message.attachments?.length > 0 && (
//             <div className='space-y-2'>
//               {message.attachments.map((attachment, index) => (
//                 <div key={index} className='relative'>
//                   <img
//                     src={
//                       attachment.filePath.startsWith('http')
//                         ? attachment.filePath
//                         : `${BASE_URL}${attachment.filePath}`
//                     }
//                     alt={attachment.originalName}
//                     className='max-w-[200px] h-auto rounded-lg cursor-pointer transition-opacity duration-200 hover:opacity-80'
//                     onClick={() => handleOpenFile(attachment)}
//                     onLoad={() => setIsLoading(false)}
//                     onError={e => {
//                       console.error(
//                         'Image failed to load:',
//                         attachment.filePath
//                       )
//                       e.target.src = '/path/to/fallback-image.png'
//                       setIsLoading(false)
//                     }}
//                   />
//                   {isLoading && (
//                     <div className='absolute inset-0 flex items-center justify-center bg-black/50 rounded-lg'>
//                       <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-teal-300'></div>
//                     </div>
//                   )}
//                   <div className='absolute inset-0 bg-black/30 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-200'>
//                     <button
//                       onClick={() => handleOpenFile(attachment)}
//                       className='text-white text-sm mr-2'
//                     >
//                       View
//                     </button>
//                     <button
//                       onClick={() => handleDownloadFile(attachment)}
//                       className='text-white text-sm'
//                     >
//                       Download
//                     </button>
//                   </div>
//                 </div>
//               ))}
//               {message.content && (
//                 <p className='whitespace-pre-wrap break-words mt-2'>
//                   {message.content}
//                 </p>
//               )}
//             </div>
//           )}

//           {message.messageType === 'file' && message.attachments?.length > 0 && (
//             <div className='space-y-2'>
//               {message.attachments.map((attachment, index) => (
//                 <div
//                   key={index}
//                   className='flex items-center space-x-2 p-2 bg-slate-600/30 rounded'
//                 >
//                   <Paperclip className='w-4 h-4' />
//                   <span className='text-sm truncate'>
//                     {attachment.originalName}
//                   </span>
//                   <div className='flex space-x-2'>
//                     <button
//                       onClick={() => handleOpenFile(attachment)}
//                       className='text-teal-400 hover:text-teal-300 text-xs'
//                     >
//                       Open
//                     </button>
//                     <button
//                       onClick={() => handleDownloadFile(attachment)}
//                       className='text-teal-400 hover:text-teal-300 text-xs'
//                     >
//                       Download
//                     </button>
//                   </div>
//                 </div>
//               ))}
//               {message.content && (
//                 <p className='whitespace-pre-wrap break-words mt-2'>
//                   {message.content}
//                 </p>
//               )}
//             </div>
//           )}
//         </div>

//         <div
//           className={`flex items-center justify-between text-xs ${isOwn ? 'text-teal-100' : 'text-slate-400'
//             }`}
//         >
//           <span>{formatTime(message.sentAt)}</span>
//           {isOwn && <div className='ml-2'>{getMessageStatus()}</div>}
//         </div>

//         <button
//           onClick={handleLongPress}
//           className='absolute top-2 right-2 opacity-0 group-hover:opacity-100 p-1 hover:bg-slate-600/50 rounded transition-opacity'
//         >
//           <MoreVertical className='w-4 h-4' />
//         </button>
//       </div>
//     </div>
//   )
// }
// // Message Actions Modal
// const MessageActionsModal = ({ message, onAction, onClose }) => {
//   const actions = [
//     { id: 'pin', label: message.isPinned ? 'Unpin' : 'Pin', icon: Pin },
//     { id: 'forward', label: 'Forward', icon: Forward },
//     { id: 'delete', label: 'Delete', icon: Trash2, destructive: true }
//   ]

//   return (
//     <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50'>
//       <div className='bg-slate-800 rounded-lg p-4 min-w-48'>
//         <div className='flex items-center justify-between mb-4'>
//           <h3 className='font-semibold text-teal-300'>Message Actions</h3>
//           <button onClick={onClose} className='p-1 hover:bg-slate-700 rounded'>
//             <X className='w-4 h-4' />
//           </button>
//         </div>

//         <div className='space-y-2'>
//           {actions.map(action => (
//             <button
//               key={action.id}
//               onClick={() => onAction(action.id, message._id)}
//               className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors ${action.destructive
//                 ? 'hover:bg-red-500/20 text-red-400'
//                 : 'hover:bg-slate-700 text-teal-300'
//                 }`}
//             >
//               <action.icon className='w-4 h-4' />
//               <span>{action.label}</span>
//             </button>
//           ))}
//         </div>
//       </div>
//     </div>
//   )
// }

// // Search Results Component
// const SearchResults = ({ results, onResultClick }) => {
//   return (
//     <div className='p-2'>
//       <h3 className='text-sm font-semibold text-slate-400 mb-2'>
//         Search Results
//       </h3>
//       <div className='space-y-1'>
//         {results.map(message => (
//           <div
//             key={message._id}
//             onClick={() => onResultClick(message.conversationId)}
//             className='p-3 hover:bg-slate-700/30 rounded-lg cursor-pointer'
//           >
//             <div className='flex items-center space-x-2 mb-1'>
//               <span className='text-sm font-medium text-teal-300'>
//                 {message.sender.username}
//               </span>
//               <span className='text-xs text-slate-400'>
//                 {new Date(message.sentAt).toLocaleDateString()}
//               </span>
//             </div>
//             <p className='text-sm text-slate-300 truncate'>{message.content}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   )
// }

// // Empty State Component
// const EmptyState = () => {
//   return (
//     <div className='flex items-center justify-center h-full'>
//       <div className='text-center'>
//         <MessageSquare className='w-16 h-16 text-slate-600 mx-auto mb-4' />
//         <h2 className='text-xl font-semibold text-slate-400 mb-2'>
//           No conversation selected
//         </h2>
//         <p className='text-slate-500'>
//           Choose a conversation from the sidebar to start messaging
//         </p>
//       </div>
//     </div>
//   )
// }

// export default MessagingApp

import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Send,
  Search,
  MoreVertical,
  Paperclip,
  Smile,
  Info,
  ArrowLeft,
  Pin,
  Forward,
  Trash2,
  Check,
  CheckCheck,
  Clock,
  Online,
  MessageSquare,
  Users,
  X,
  Plus,
  Image,
  FileText,
  Download,
  Eye,
  ChevronDown,
  Settings,
  Archive,
  Star
} from 'lucide-react'
import EmojiPicker from 'emoji-picker-react'
import {
  sendMessageThunk,
  getConversationsThunk,
  getConversationMessagesThunk,
  searchMessagesThunk,
  pinMessageThunk,
  forwardMessageThunk,
  deleteMessageThunk,
  getUserPresenceThunk,
  setCurrentConversation,
  clearSearchResults,
  clearError,
  addMessageToConversation,
  updateMessageStatus,
  addTempConversation,
  updateMessageDeliveryStatus,
  markConversationRead
} from '../store/API/messageSlice'
import { fetchAllUsers, checkActiveUser } from '../store/slices/authSlice'
import {
  initSocket,
  emitJoinConversation,
  emitLeaveConversation,
  emitMarkAsRead,
  emitMessageDelivered,
  emitTyping,
  isSocketConnected
} from '../socket'
import ImagePreviewModal from './ImagePreviewModal'

// Main App Component
const MessagingApp = () => {
  const dispatch = useDispatch()
  const {
    conversations,
    conversationMessages,
    searchResults,
    userPresence,
    loading,
    error,
    currentConversationId,
    pagination
  } = useSelector(state => state.messages)

  const { user, activeUser } = useSelector(state => state.auth)

  const currentUserId =
    activeUser?._id || activeUser?.id || user?._id || user?.id

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [showConversations, setShowConversations] = useState(true)
  const [searchQuery, setSearchQuery] = useState('')
  const [showSearch, setShowSearch] = useState(false)
  const [showAddUserModal, setShowAddUserModal] = useState(false)
  const [isTyping, setIsTyping] = useState(false)
  const typingTimeoutRef = useRef(null)

  // Initialize socket connection
  useEffect(() => {
    if (!isSocketConnected()) {
      initSocket()
    }

    return () => {
      if (currentConversationId) {
        emitLeaveConversation(currentConversationId)
      }
    }
  }, [])

  useEffect(() => {
    if (!activeUser && user) {
      dispatch(checkActiveUser())
    }
  }, [dispatch, activeUser, user])

  useEffect(() => {
    const handleNewMessage = data => {
      console.log('New message received:', data)
      if (data && data.data && data.conversationId) {
        dispatch(
          addMessageToConversation({
            conversationId: data.conversationId,
            message: data.data
          })
        )

        // If viewing this conversation, mark as read immediately
        if (data.conversationId === currentConversationId) {
          emitMarkAsRead(data.conversationId)
        }
        if (data.conversationId === currentConversationId) {
          emitMessageDelivered(data.conversationId)
        }

        // Refresh conversations to update unread counts
        dispatch(getConversationsThunk())
      }
    }

    const handleConversationRead = data => {
      console.log('Conversation read event received:', data)
      dispatch(
        markConversationRead({
          conversationId: data.conversationId,
          userId: data.userId,
          unreadCount: data.unreadCount || 0
        })
      )

      // Refresh conversations to get updated counts
      dispatch(getConversationsThunk())
    }

    const handleMessageDeliveryUpdate = data => {
      console.log('Message delivery update received:', data)
      dispatch(
        updateMessageDeliveryStatus({
          messageId: data.messageId,
          userId: data.userId,
          status: data.status
        })
      )
    }

    window.addEventListener('newMessage', e => handleNewMessage(e.detail))
    window.addEventListener('conversationRead', e =>
      handleConversationRead(e.detail)
    )
    window.addEventListener('messageDeliveryUpdate', e =>
      handleMessageDeliveryUpdate(e.detail)
    )

    return () => {
      window.removeEventListener('newMessage', e => handleNewMessage(e.detail))
      window.removeEventListener('conversationRead', e =>
        handleConversationRead(e.detail)
      )
      window.removeEventListener('messageDeliveryUpdate', e =>
        handleMessageDeliveryUpdate(e.detail)
      )
    }
  }, [dispatch, currentConversationId])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    dispatch(getConversationsThunk())
  }, [dispatch])

  useEffect(() => {
    if (currentConversationId) {
      emitJoinConversation(currentConversationId)
      emitMarkAsRead(currentConversationId)
    }

    return () => {
      if (currentConversationId) {
        emitLeaveConversation(currentConversationId)
      }
    }
  }, [currentConversationId])

  const handleConversationSelect = conversationId => {
    if (!conversationId) return

    dispatch(setCurrentConversation(conversationId))
    dispatch(getConversationMessagesThunk({ conversationId }))
    dispatch(
      markConversationRead({
        conversationId,
        userId: currentUserId,
        unreadCount: 0
      })
    )
    emitMarkAsRead(conversationId)

    if (isMobile) {
      setShowConversations(false)
    }
  }

  const handleBackToConversations = () => {
    setShowConversations(true)
    dispatch(setCurrentConversation(null))
  }

  const handleSearch = query => {
    if (query.trim()) {
      dispatch(searchMessagesThunk({ query }))
      setShowSearch(true)
    } else {
      dispatch(clearSearchResults())
      setShowSearch(false)
    }
  }

  const handleAddUser = async selectedUser => {
    try {
      const existingConversation = conversations.find(
        conv =>
          conv.conversationType === 'direct' &&
          conv.participants.some(
            participant => participant._id === selectedUser._id
          )
      )

      if (existingConversation) {
        handleConversationSelect(existingConversation._id)
      } else {
        const tempConversation = {
          _id: `temp_${Date.now()}_${selectedUser._id}`,
          participants: [selectedUser],
          conversationType: 'direct',
          lastMessage: null,
          lastActivity: new Date(),
          unreadCount: 0
        }

        dispatch(addTempConversation(tempConversation))
        handleConversationSelect(tempConversation._id)
      }

      setShowAddUserModal(false)
    } catch (error) {
      console.error('Failed to add user:', error)
    }
  }

  return (
    <div className='h-[86vh] bg-gradient-to-br from-slate-900 via-slate-950 to-slate-900 text-teal-300 flex overflow-hidden rounded-2xl shadow-2xl border border-slate-700/30'>
      {/* Sidebar - Conversations */}
      <div
        className={`${
          isMobile ? (showConversations ? 'w-full' : 'hidden') : 'w-1/4'
        } bg-gradient-to-b from-slate-800/60 to-slate-900/60 border-r border-slate-700/30 flex flex-col backdrop-blur-xl`}
      >
        {/* Enhanced Header */}
        <div className='p-6 border-b border-slate-700/20 bg-gradient-to-r from-slate-800/80 to-slate-700/80 backdrop-blur-sm'>
          <div className='flex items-center justify-between mb-6'>
            <div className='flex items-center space-x-3'>
              <div className='w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center shadow-lg'>
                <MessageSquare className='w-6 h-6 text-white' />
              </div>
              <div>
                <h1 className='text-2xl font-bold text-teal-300 tracking-wide'>
                  Messages
                </h1>
                <p className='text-xs text-slate-400'>
                  {conversations.length} conversations
                </p>
              </div>
            </div>
            <div className='flex items-center space-x-2'>
              <button
                onClick={() => setShowAddUserModal(true)}
                className='p-3 hover:bg-slate-700/50 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-lg'
              >
                <Plus className='w-5 h-5' />
              </button>
              <button className='p-3 hover:bg-slate-700/50 rounded-full transition-all duration-300 hover:scale-105'>
                <Settings className='w-5 h-5' />
              </button>
            </div>
          </div>

          {/* Enhanced Search */}
          <div className='relative'>
            <Search className='absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400' />
            <input
              type='text'
              placeholder='Search conversations and users...'
              value={searchQuery}
              onChange={e => {
                setSearchQuery(e.target.value)
                handleSearch(e.target.value)
              }}
              className='w-full pl-12 pr-4 py-3 bg-slate-700/50 border border-slate-600/30 rounded-xl text-teal-300 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500/50 focus:border-teal-500/50 transition-all duration-300 backdrop-blur-sm'
            />
          </div>
        </div>

        {/* Conversations List with Enhanced Styling */}
        <div className='flex-1 overflow-y-auto custom-scrollbar'>
          {showSearch && searchResults.length > 0 ? (
            <SearchResults
              results={searchResults}
              onResultClick={conversationId => {
                handleConversationSelect(conversationId)
                setShowSearch(false)
                setSearchQuery('')
                dispatch(clearSearchResults())
              }}
            />
          ) : (
            <ConversationsList
              conversations={conversations}
              currentConversationId={currentConversationId}
              onConversationSelect={handleConversationSelect}
              loading={loading.getConversations}
              userPresence={userPresence}
            />
          )}
        </div>
      </div>

      {/* Main Chat Area */}
      <div
        className={`${
          isMobile ? (showConversations ? 'hidden' : 'w-full') : 'flex-1'
        } flex flex-col bg-gradient-to-b from-slate-900/40 to-slate-950/40 backdrop-blur-sm`}
      >
        {currentConversationId ? (
          <ChatWindow
            conversationId={currentConversationId}
            messages={
              conversationMessages[currentConversationId]?.messages || []
            }
            loading={loading}
            error={error}
            onBack={isMobile ? handleBackToConversations : undefined}
            userPresence={userPresence}
          />
        ) : (
          <EmptyState />
        )}
      </div>

      <AddUserModal
        show={showAddUserModal}
        onClose={() => setShowAddUserModal(false)}
        onAddUser={handleAddUser}
      />

      {/* Custom Scrollbar Styles */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(15, 23, 42, 0.3);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(20, 184, 166, 0.3);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(20, 184, 166, 0.5);
        }
      `}</style>
    </div>
  )
}

// Enhanced Conversations List Component
const ConversationsList = ({
  conversations,
  currentConversationId,
  onConversationSelect,
  loading,
  userPresence,
  pagination
}) => {
  const dispatch = useDispatch()

  const loadMoreConversations = () => {
    const nextPage = pagination?.conversations?.page + 1
    if (pagination?.conversations?.hasMore) {
      dispatch(getConversationsThunk({ page: nextPage }))
    }
  }

  if (loading && conversations.length === 0) {
    return (
      <div className='flex items-center justify-center h-64'>
        <div className='relative'>
          <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-teal-300'></div>
          <div className='absolute inset-0 rounded-full border-2 border-slate-700/20'></div>
        </div>
      </div>
    )
  }

  return (
    <div className='space-y-1 p-3'>
      {conversations.map(conversation => (
        <ConversationItem
          key={conversation._id}
          conversation={conversation}
          isActive={conversation._id === currentConversationId}
          onClick={() => onConversationSelect(conversation._id)}
          userPresence={userPresence}
        />
      ))}

      {pagination?.conversations?.hasMore && (
        <button
          onClick={loadMoreConversations}
          disabled={loading}
          className='w-full py-3 text-sm text-slate-400 hover:text-teal-300 transition-colors hover:bg-slate-700/20 rounded-lg'
        >
          {loading ? 'Loading...' : 'Load More Conversations'}
        </button>
      )}
    </div>
  )
}

// Enhanced Individual Conversation Item
const ConversationItem = ({
  conversation,
  isActive,
  onClick,
  userPresence
}) => {
  const { user, activeUser } = useSelector(state => state.auth)
  const currentUserId =
    activeUser?._id || activeUser?.id || user?._id || user?.id

  const getConversationName = () => {
    if (conversation.conversationType === 'group') {
      return conversation.group?.name || 'Group Chat'
    } else {
      return conversation.participants[0]?.username || 'Unknown User'
    }
  }

  const getLastMessagePreview = () => {
    if (!conversation.lastMessage) return 'No messages yet'

    const content = conversation.lastMessage.content
    if (conversation.lastMessage.messageType === 'file') {
      return '📎 File attachment'
    } else if (conversation.lastMessage.messageType === 'image') {
      return '🖼️ Image'
    } else if (conversation.lastMessage.messageType === 'forward') {
      return '↩️ Forwarded message'
    }
    return content?.substring(0, 45) + (content?.length > 45 ? '...' : '')
  }

  const getLastMessageTime = () => {
    if (!conversation.lastMessage?.sentAt) return ''

    const date = new Date(conversation.lastMessage.sentAt)
    const now = new Date()
    const diffInHours = (now - date) / (1000 * 60 * 60)

    if (diffInHours < 1) {
      return 'now'
    } else if (diffInHours < 24) {
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })
    } else if (diffInHours < 168) {
      return date.toLocaleDateString([], { weekday: 'short' })
    } else {
      return date.toLocaleDateString([], { month: 'short', day: 'numeric' })
    }
  }

  const isUserOnline = () => {
    if (conversation.conversationType === 'group') return false
    const userId = conversation.participants[0]?._id
    return userPresence[userId]?.isOnline || false
  }

  const getUnreadCount = () => {
    if (typeof conversation.unreadCount === 'number') {
      return conversation.unreadCount
    }
    if (Array.isArray(conversation.unreadCount)) {
      const unreadEntry = conversation.unreadCount.find(
        u => u.user && u.user.toString() === currentUserId
      )
      return unreadEntry ? unreadEntry.count : 0
    }
    return 0
  }

  return (
    <div
      onClick={onClick}
      className={`group flex items-center p-4 rounded-2xl cursor-pointer transition-all duration-300 hover:scale-[1.02] hover:shadow-lg ${
        isActive
          ? 'bg-gradient-to-r from-teal-600/20 via-teal-500/10 to-transparent border-l-4 border-teal-400 shadow-lg transform scale-[1.02]'
          : 'hover:bg-slate-700/30 hover:backdrop-blur-sm'
      }`}
    >
      {/* Enhanced Avatar */}
      <div className='relative'>
        <div
          className={`w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg ring-2 ${
            isActive ? 'ring-teal-400/50' : 'ring-transparent'
          } transition-all duration-300`}
        >
          {conversation.conversationType === 'group' ? (
            <Users className='w-7 h-7' />
          ) : (
            getConversationName().charAt(0).toUpperCase()
          )}
        </div>
        {isUserOnline() && (
          <div className='absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 border-3 border-slate-800 rounded-full shadow-md animate-pulse'></div>
        )}
        {getUnreadCount() > 0 && (
          <div className='absolute -top-2 -right-2 min-w-[20px] h-5 bg-gradient-to-r from-red-500 to-red-600 text-white text-xs rounded-full flex items-center justify-center font-bold shadow-lg animate-bounce'>
            {getUnreadCount() > 99 ? '99+' : getUnreadCount()}
          </div>
        )}
      </div>

      {/* Content */}
      <div className='ml-4 flex-1 min-w-0'>
        <div className='flex items-center justify-between mb-1'>
          <h3
            className={`font-semibold truncate transition-colors duration-300 ${
              isActive ? 'text-teal-300' : 'text-teal-200'
            }`}
          >
            {getConversationName()}
          </h3>
          <div className='flex items-center space-x-2'>
            <span className='text-xs text-slate-400 font-medium'>
              {getLastMessageTime()}
            </span>
            {isActive && (
              <ChevronDown className='w-4 h-4 text-teal-400 animate-pulse' />
            )}
          </div>
        </div>

        <div className='flex items-center justify-between'>
          <p className='text-sm text-slate-400 truncate group-hover:text-slate-300 transition-colors duration-300'>
            {getLastMessagePreview()}
          </p>
          <div className='flex items-center space-x-1 ml-2'>
            {conversation.lastMessage?.isPinned && (
              <Pin className='w-3 h-3 text-yellow-400' />
            )}
            {isUserOnline() && conversation.conversationType !== 'group' && (
              <div className='w-2 h-2 bg-green-500 rounded-full animate-pulse'></div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

// Enhanced Add User Modal
const AddUserModal = ({ show, onClose, onAddUser }) => {
  const dispatch = useDispatch()
  const { users, status } = useSelector(state => state.auth)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    if (show && (!users || users.length === 0)) {
      dispatch(fetchAllUsers())
    }
  }, [show, users, dispatch])

  const filteredUsers =
    users?.filter(
      user =>
        user.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.email?.toLowerCase().includes(searchTerm.toLowerCase())
    ) || []

  if (!show) return null

  return (
    <div className='fixed inset-0 bg-black/60 flex items-center justify-center z-50 backdrop-blur-sm'>
      <div className='bg-gradient-to-br from-slate-800 to-slate-900 rounded-3xl p-8 w-96 max-h-[80vh] shadow-2xl border border-slate-700/50 backdrop-blur-xl'>
        <div className='flex items-center justify-between mb-6'>
          <div>
            <h3 className='text-xl font-bold text-teal-300'>Start New Chat</h3>
            <p className='text-sm text-slate-400 mt-1'>
              Choose a user to message
            </p>
          </div>
          <button
            onClick={onClose}
            className='p-2 hover:bg-slate-700/50 rounded-full transition-all duration-300 hover:scale-110'
          >
            <X className='w-5 h-5' />
          </button>
        </div>

        {/* Enhanced Search Input */}
        <div className='relative mb-6'>
          <Search className='absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400' />
          <input
            type='text'
            placeholder='Search users by name or email...'
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className='w-full pl-12 pr-4 py-3 bg-slate-700/50 border border-slate-600/30 rounded-xl text-teal-300 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500/50 transition-all duration-300'
          />
        </div>

        {/* Users List */}
        <div className='max-h-80 overflow-y-auto space-y-2 custom-scrollbar'>
          {status === 'loading' ? (
            <div className='flex items-center justify-center py-8'>
              <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-teal-300'></div>
            </div>
          ) : filteredUsers.length > 0 ? (
            filteredUsers.map(user => (
              <div
                key={user._id}
                onClick={() => onAddUser(user)}
                className='flex items-center space-x-4 p-3 hover:bg-slate-700/40 rounded-xl cursor-pointer transition-all duration-300 hover:scale-[1.02] hover:shadow-md'
              >
                <div className='w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center text-white font-bold shadow-md'>
                  {user.username?.charAt(0).toUpperCase()}
                </div>
                <div className='flex-1 min-w-0'>
                  <p className='font-semibold text-teal-300 truncate'>
                    {user.username}
                  </p>
                  <p className='text-sm text-slate-400 truncate'>
                    {user.email}
                  </p>
                </div>
                <ChevronDown className='w-4 h-4 text-slate-400 transform rotate-[-90deg]' />
              </div>
            ))
          ) : (
            <div className='text-center py-8'>
              <Users className='w-12 h-12 text-slate-500 mx-auto mb-3' />
              <p className='text-slate-400'>No users found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

// Enhanced Chat Window
const ChatWindow = ({
  conversationId,
  messages,
  loading,
  error,
  onBack,
  userPresence
}) => {
  const dispatch = useDispatch()
  const { user, activeUser } = useSelector(state => state.auth)

  const [messageInput, setMessageInput] = useState('')
  const [selectedMessage, setSelectedMessage] = useState(null)
  const [showMessageActions, setShowMessageActions] = useState(false)
  const [isTyping, setIsTyping] = useState(false)
  const messagesEndRef = useRef(null)
  const fileInputRef = useRef(null)
  const typingTimeoutRef = useRef(null)
  const [fileUploadError, setFileUploadError] = useState(null)
  const [isUploadingFile, setIsUploadingFile] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState([])
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [messageToDelete, setMessageToDelete] = useState(null)
  const [imagePreview, setImagePreview] = useState({
    isOpen: false,
    imageUrl: '',
    imageName: ''
  })
  const currentConversation = useSelector(state =>
    state.messages.conversations.find(conv => conv._id === conversationId)
  )

  useEffect(() => {
    scrollToBottom()
  }, [messages])

  useEffect(() => {
    if (conversationId && currentConversation?.participants?.length > 0) {
      currentConversation.participants.forEach(participant => {
        if (participant._id) {
          dispatch(getUserPresenceThunk(participant._id)).catch(error => {
            console.log(`User ${participant._id} appears to be offline`)
          })
        }
      })
    }
  }, [conversationId, currentConversation, dispatch])

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }

  const handleFileUpload = (event, type) => {
    const files = Array.from(event.target.files)
    if (files.length === 0) return

    const maxFileSize = 10 * 1024 * 1024

    const invalidFiles = files.filter(file => {
      if (file.size > maxFileSize) return true
      if (type === 'image') {
        const allowedImageTypes = [
          'image/png',
          'image/jpeg',
          'image/gif',
          'image/webp'
        ]
        return !allowedImageTypes.includes(file.type)
      }
      return false
    })

    if (invalidFiles.length > 0) {
      const sizeIssues = invalidFiles.filter(f => f.size > maxFileSize)
      const typeIssues = invalidFiles.filter(f => f.size <= maxFileSize)

      let errorMessage = ''
      if (sizeIssues.length > 0) {
        errorMessage += `Files too large (max 10MB): ${sizeIssues
          .map(f => f.name)
          .join(', ')}. `
      }
      if (typeIssues.length > 0 && type === 'image') {
        errorMessage += `Invalid image files: ${typeIssues
          .map(f => f.name)
          .join(', ')}.`
      }

      setFileUploadError(errorMessage)
      return
    }

    setSelectedFiles(files)
    setFileUploadError(null)
  }

  const handleSendMessage = async () => {
    if (!messageInput.trim() && selectedFiles.length === 0) return

    if (isTyping) {
      emitTyping(
        conversationId,
        currentConversation.participants[0]?._id,
        false
      )
      setIsTyping(false)
    }

    try {
      let messageData

      if (selectedFiles.length > 0) {
        setIsUploadingFile(true)
        setFileUploadError(null)

        const formData = new FormData()

        selectedFiles.forEach(file => {
          formData.append('attachments', file)
        })

        if (messageInput.trim()) {
          formData.append('content', messageInput)
        }

        const isImage = selectedFiles.every(file =>
          ['image/png', 'image/jpeg', 'image/gif', 'image/webp'].includes(
            file.type
          )
        )
        formData.append('messageType', isImage ? 'image' : 'file')

        if (currentConversation?.conversationType === 'group') {
          formData.append('groupId', currentConversation.group._id)
        } else {
          let receiverId
          if (conversationId.startsWith('temp_')) {
            receiverId = currentConversation?.participants?.[0]?._id
          } else {
            receiverId = currentConversation?.participants?.[0]?._id
          }

          if (!receiverId) {
            setFileUploadError('No valid receiver found')
            setIsUploadingFile(false)
            return
          }

          formData.append('receiverId', receiverId)
        }

        messageData = formData
      } else {
        messageData = {
          content: messageInput,
          messageType: 'text'
        }

        if (currentConversation?.conversationType === 'group') {
          messageData.groupId = currentConversation.group._id
        } else {
          let receiverId
          if (conversationId.startsWith('temp_')) {
            receiverId = currentConversation?.participants?.[0]?._id
          } else {
            receiverId = currentConversation?.participants?.[0]?._id
          }

          if (!receiverId) {
            throw new Error('No valid receiver found')
          }
          messageData.receiverId = receiverId
        }
      }

      await dispatch(sendMessageThunk(messageData)).unwrap()

      setSelectedFiles([])
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
      setMessageInput('')
      scrollToBottom()
    } catch (error) {
      console.error('Failed to send message:', error)
      if (selectedFiles.length > 0) {
        setFileUploadError(error.message || 'Failed to send message with files')
      }
    } finally {
      if (selectedFiles.length > 0) {
        setIsUploadingFile(false)
      }
    }
  }

  const removeSelectedFile = indexToRemove => {
    setSelectedFiles(prev => prev.filter((_, index) => index !== indexToRemove))
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handleMessageAction = (action, messageId) => {
    switch (action) {
      case 'pin':
        dispatch(pinMessageThunk({ messageId, pin: true }))
        break
      case 'forward':
        break
      case 'delete':
        const messageToDelete = messages.find(msg => msg._id === messageId)
        setMessageToDelete(messageToDelete)
        setShowDeleteModal(true)
        break
      default:
        break
    }
    setShowMessageActions(false)
    setSelectedMessage(null)
  }

  const handleDeleteMessage = deleteType => {
    if (!messageToDelete) return

    dispatch(
      deleteMessageThunk({
        messageId: messageToDelete._id,
        deleteType
      })
    )
    setMessageToDelete(null)
  }

  const handleTyping = value => {
    setMessageInput(value)

    if (!isTyping) {
      setIsTyping(true)
      emitTyping(conversationId, currentConversation.participants[0]?._id, true)
    }

    clearTimeout(typingTimeoutRef.current)
    typingTimeoutRef.current = setTimeout(() => {
      setIsTyping(false)
      emitTyping(
        conversationId,
        currentConversation.participants[0]?._id,
        false
      )
    }, 3000)
  }

  const handleEmojiSelect = emojiData => {
    setMessageInput(prev => prev + emojiData.emoji)
    setShowEmojiPicker(false)
  }

  const getConversationTitle = () => {
    if (!currentConversation) return 'Loading...'

    if (currentConversation.conversationType === 'group') {
      return currentConversation.group?.name || 'Group Chat'
    } else {
      return currentConversation.participants[0]?.username || 'Unknown User'
    }
  }

  const isUserOnline = () => {
    if (
      !currentConversation ||
      currentConversation.conversationType === 'group'
    )
      return false
    const userId = currentConversation.participants[0]?._id
    return userPresence[userId]?.isOnline || false
  }

  const DeleteMessageModal = ({ show, onClose, onDelete, isOwnMessage }) => {
    if (!show) return null

    const handleDelete = deleteType => {
      onDelete(deleteType)
      onClose()
    }

    return (
      <div className='fixed inset-0 bg-black/60 flex items-center justify-center z-50 backdrop-blur-sm'>
        <div className='bg-gradient-to-br from-slate-800 to-slate-900 rounded-3xl p-8 w-96 shadow-2xl border border-slate-700/50 backdrop-blur-xl'>
          <div className='text-center mb-6'>
            <h3 className='text-xl font-bold text-teal-300 mb-2'>
              Delete Message
            </h3>
            <p className='text-sm text-slate-400'>
              {isOwnMessage
                ? 'Choose how you want to delete this message'
                : 'Are you sure you want to delete this message?'}
            </p>
          </div>

          <div className='space-y-3'>
            {isOwnMessage ? (
              <>
                <button
                  onClick={() => handleDelete('onlyForYou')}
                  className='w-full p-4 text-left hover:bg-slate-700/50 rounded-xl transition-all duration-300'
                >
                  <div className='font-semibold text-teal-300'>
                    Delete for me
                  </div>
                  <div className='text-sm text-slate-400'>
                    This message will be deleted from this device only
                  </div>
                </button>

                <button
                  onClick={() => handleDelete('forEveryone')}
                  className='w-full p-4 text-left hover:bg-slate-700/50 rounded-xl transition-all duration-300'
                >
                  <div className='font-semibold text-teal-300'>
                    Delete for everyone
                  </div>
                  <div className='text-sm text-slate-400'>
                    This message will be deleted for all participants
                  </div>
                </button>
              </>
            ) : (
              <div className='flex space-x-3'>
                <button
                  onClick={() => handleDelete('onlyForYou')}
                  className='flex-1 py-3 bg-red-600 hover:bg-red-500 rounded-xl text-white font-semibold transition-colors'
                >
                  Yes, Delete
                </button>
                <button
                  onClick={onClose}
                  className='flex-1 py-3 bg-slate-700 hover:bg-slate-600 rounded-xl text-slate-300 font-semibold transition-colors'
                >
                  Cancel
                </button>
              </div>
            )}
          </div>

          {isOwnMessage && (
            <button
              onClick={onClose}
              className='w-full mt-4 py-3 text-slate-400 hover:text-slate-300 transition-colors'
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    )
  }

  if (loading.getConversationMessages && messages.length === 0) {
    return (
      <div className='flex items-center justify-center h-full'>
        <div className='text-center'>
          <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-teal-300 mx-auto mb-4'></div>
          <p className='text-slate-400'>Loading messages...</p>
        </div>
      </div>
    )
  }

  return (
    <div className='flex flex-col h-full'>
      {/* Enhanced Chat Header */}
      <div className='p-6 border-b border-slate-700/30 bg-gradient-to-r from-slate-800/60 to-slate-700/60 backdrop-blur-sm'>
        <div className='flex items-center justify-between'>
          <div className='flex items-center space-x-4'>
            {onBack && (
              <button
                onClick={onBack}
                className='p-2 hover:bg-slate-700/50 rounded-full transition-all duration-300 hover:scale-110'
              >
                <ArrowLeft className='w-5 h-5' />
              </button>
            )}

            <div className='relative'>
              <div className='w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center text-white font-bold shadow-lg'>
                {currentConversation?.conversationType === 'group' ? (
                  <Users className='w-6 h-6' />
                ) : (
                  getConversationTitle().charAt(0).toUpperCase()
                )}
              </div>
              {isUserOnline() && (
                <div className='absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-slate-800 rounded-full animate-pulse'></div>
              )}
            </div>

            <div>
              <h2 className='text-xl font-semibold text-teal-300'>
                {getConversationTitle()}
              </h2>
              <p className='text-sm text-slate-400'>
                {isUserOnline() ? 'Online' : 'Offline'}
                {currentConversation?.conversationType === 'group' &&
                  ` • ${currentConversation.participants?.length || 0} members`}
              </p>
            </div>
          </div>

          <div className='flex items-center space-x-2'>
            <button className='p-3 hover:bg-slate-700/50 rounded-full transition-all duration-300 hover:scale-105'>
              <Search className='w-5 h-5' />
            </button>
            <button className='p-3 hover:bg-slate-700/50 rounded-full transition-all duration-300 hover:scale-105'>
              <Info className='w-5 h-5' />
            </button>
            <button className='p-3 hover:bg-slate-700/50 rounded-full transition-all duration-300 hover:scale-105'>
              <MoreVertical className='w-5 h-5' />
            </button>
          </div>
        </div>
      </div>

      <div className='flex-1 overflow-y-auto p-6 space-y-4 custom-scrollbar'>
        {messages.map((message, index) => {
          const currentDate = new Date(message.sentAt).toDateString()
          const previousDate =
            index > 0
              ? new Date(messages[index - 1].sentAt).toDateString()
              : null
          const showDateSeparator = currentDate !== previousDate

          return (
            <div key={message._id}>
              {showDateSeparator && (
                <div className='flex justify-center my-4'>
                  <span className='text-xs text-slate-400 bg-slate-700/30 px-4 py-2 rounded-full'>
                    {new Date(message.sentAt).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric'
                    })}
                  </span>
                </div>
              )}
              <MessageBubble
                message={message}
                isOwn={
                  message.sender._id ===
                  currentConversation?.participants?.[0]?._id
                }
                showTime={
                  index === 0 ||
                  new Date(message.sentAt).getTime() -
                    new Date(messages[index - 1].sentAt).getTime() >
                    5 * 60 * 1000
                }
                onMessageAction={handleMessageAction}
                selectedMessage={selectedMessage}
                setSelectedMessage={setSelectedMessage}
                showMessageActions={showMessageActions}
                setShowMessageActions={setShowMessageActions}
                setImagePreview={setImagePreview}
              />
            </div>
          )
        })}
        <div ref={messagesEndRef} />
      </div>

      {/* File Preview Section */}
      {selectedFiles.length > 0 && (
        <div className='px-6 py-3 border-t border-slate-700/30 bg-slate-800/50'>
          <div className='flex flex-wrap gap-2 mb-3'>
            {selectedFiles.map((file, index) => (
              <div
                key={index}
                className='flex items-center space-x-2 bg-slate-700/50 rounded-lg p-2'
              >
                {file.type.startsWith('image/') ? (
                  <Image className='w-4 h-4 text-teal-400' />
                ) : (
                  <FileText className='w-4 h-4 text-teal-400' />
                )}
                <span className='text-sm text-teal-300 truncate max-w-32'>
                  {file.name}
                </span>
                <button
                  onClick={() => removeSelectedFile(index)}
                  className='p-1 hover:bg-slate-600/50 rounded-full'
                >
                  <X className='w-3 h-3' />
                </button>
              </div>
            ))}
          </div>
          {fileUploadError && (
            <p className='text-red-400 text-sm mb-2'>{fileUploadError}</p>
          )}
        </div>
      )}

      {/* Enhanced Message Input */}
      <div className='p-6 border-t border-slate-700/30 bg-gradient-to-r from-slate-800/40 to-slate-700/40 backdrop-blur-sm'>
        <div className='flex items-end space-x-3'>
          <div className='flex space-x-2'>
            <input
              type='file'
              ref={fileInputRef}
              multiple
              accept='image/*,application/pdf,.doc,.docx,.txt'
              onChange={e => handleFileUpload(e, 'file')}
              className='hidden'
            />
            <button
              onClick={() => fileInputRef.current?.click()}
              disabled={isUploadingFile}
              className='p-3 hover:bg-slate-700/50 rounded-full transition-all duration-300 hover:scale-110 disabled:opacity-50'
            >
              <Paperclip className='w-5 h-5' />
            </button>

            <button
              onClick={() => setShowEmojiPicker(!showEmojiPicker)}
              className='p-3 hover:bg-slate-700/50 rounded-full transition-all duration-300 hover:scale-110'
            >
              <Smile className='w-5 h-5' />
            </button>
          </div>

          <div className='flex-1 relative'>
            <textarea
              value={messageInput}
              onChange={e => handleTyping(e.target.value)}
              onKeyPress={e => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault()
                  handleSendMessage()
                }
              }}
              placeholder='Type a message...'
              rows='1'
              disabled={isUploadingFile}
              className='w-full px-4 py-3 bg-slate-700/50 border border-slate-600/30 rounded-2xl text-teal-300 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500/50 resize-none disabled:opacity-50 transition-all duration-300'
              style={{
                minHeight: '48px',
                maxHeight: '120px',
                overflowY:
                  messageInput.split('\n').length > 3 ? 'scroll' : 'hidden'
              }}
            />

            {showEmojiPicker && (
              <div className='absolute bottom-full right-0 mb-2 z-10'>
                <EmojiPicker
                  onEmojiClick={handleEmojiSelect}
                  theme='dark'
                  emojiStyle='native'
                />
              </div>
            )}
          </div>

          <button
            onClick={handleSendMessage}
            disabled={
              (!messageInput.trim() && selectedFiles.length === 0) ||
              isUploadingFile
            }
            className='p-3 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-400 hover:to-teal-500 rounded-full transition-all duration-300 hover:scale-110 disabled:opacity-50 disabled:hover:scale-100 shadow-lg'
          >
            {isUploadingFile ? (
              <div className='animate-spin rounded-full h-5 w-5 border-b-2 border-white'></div>
            ) : (
              <Send className='w-5 h-5 text-white' />
            )}
          </button>
        </div>
      </div>
      <DeleteMessageModal
        show={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false)
          setMessageToDelete(null)
        }}
        onDelete={handleDeleteMessage}
        isOwnMessage={
          messageToDelete?.sender._id ===
          (activeUser?._id || activeUser?.id || user?._id || user?.id)
        }
      />

      <ImagePreviewModal
        isOpen={imagePreview.isOpen}
        onClose={() =>
          setImagePreview({ isOpen: false, imageUrl: '', imageName: '' })
        }
        imageUrl={imagePreview.imageUrl}
        imageName={imagePreview.imageName}
      />
    </div>
  )
}

// Enhanced Message Bubble Component
const MessageBubble = ({
  message,
  isOwn,
  showTime,
  onMessageAction,
  selectedMessage,
  setSelectedMessage,
  showMessageActions,
  setShowMessageActions,
  setImagePreview
}) => {
  const [showActions, setShowActions] = useState(false)
  const { user, activeUser } = useSelector(state => state.auth)
  const currentUserId =
    activeUser?._id || activeUser?.id || user?._id || user?.id

  // Fix: Determine if message is from current user
  const isFromCurrentUser = message.sender._id === currentUserId

  const formatTime = timestamp => {
    return new Date(timestamp).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  // Fix: Add proper message status logic
  const getMessageStatusIcon = () => {
    if (!isFromCurrentUser) return null // Only show status for own messages

    // Check if message was read by receiver
    const isRead =
      message.readBy && message.readBy.some(read => read.user !== currentUserId)

    // Check if message was delivered
    const isDelivered =
      message.deliveredTo &&
      message.deliveredTo.some(delivery => delivery.user !== currentUserId)

    if (isRead) {
      return <CheckCheck className='w-4 h-4 text-blue-500' /> // Blue double tick
    } else if (isDelivered) {
      return <CheckCheck className='w-4 h-4 text-slate-400' /> // Grey double tick
    } else {
      return <Check className='w-4 h-4 text-slate-400' /> // Grey single tick
    }
  }

  const renderMessageContent = () => {
    if (message.isDeleted || message.messageType === 'deleted') {
      return (
        <p className='text-sm italic text-white/70'>
          🗑️ This message was deleted
        </p>
      )
    }

    switch (message.messageType) {
      case 'image':
        return (
          <div className='space-y-2'>
            {message.attachments?.map((attachment, index) => {
              const imageUrl = `${(
                process.env.REACT_APP_BACKEND_URL ||
                'http://localhost:5000/api'
              ).replace(/\/api\/?$/, '')}${attachment.filePath}`

              return (
                <div key={index} className='relative group'>
                  <div className='relative overflow-hidden rounded-lg bg-slate-800/50 max-w-xs'>
                    <img
                      src={imageUrl}
                      alt={attachment.originalName || `Attachment ${index + 1}`}
                      className='w-full h-auto object-cover rounded-lg shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer'
                      style={{
                        minHeight: '120px',
                        maxHeight: '300px',
                        minWidth: '200px',
                        maxWidth: '100%'
                      }}
                      onClick={() => {
                        setImagePreview({
                          isOpen: true,
                          imageUrl: imageUrl,
                          imageName:
                            attachment.originalName || `Image ${index + 1}`
                        })
                      }}
                      onError={e => {
                        console.error('Image failed to load:', imageUrl)
                        e.target.src =
                          'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDIwMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMTIwIiBmaWxsPSIjMzc0MTUxIi8+CjxwYXRoIGQ9Ik04MCA0MEw5MCA1MEw4MCA2MEw3MCA1MEw4MCA0MFoiIGZpbGw9IiM2Mzc0OEEiLz4KPHA+RmFpbGVkIHRvIGxvYWQ8L3A+Cjwvc3ZnPg=='
                        e.target.className += ' opacity-50'
                      }}
                      onLoad={e => {
                        const img = e.target
                        console.log('Image loaded successfully:', imageUrl)

                        if (img.naturalWidth && img.naturalHeight) {
                          const aspectRatio =
                            img.naturalWidth / img.naturalHeight

                          if (aspectRatio > 2.5) {
                            img.style.maxHeight = '150px'
                            img.style.width = 'auto'
                          } else if (aspectRatio < 0.4) {
                            img.style.maxWidth = '150px'
                            img.style.height = 'auto'
                          } else if (aspectRatio >= 0.8 && aspectRatio <= 1.2) {
                            img.style.width = '250px'
                            img.style.height = '250px'
                            img.style.objectFit = 'cover'
                          } else {
                            img.style.maxWidth = '280px'
                            img.style.maxHeight = '250px'
                          }
                        }
                      }}
                    />

                    {/* Hover overlay with eye and download buttons */}
                    <div className='absolute inset-0 bg-black/0 group-hover:bg-black/20 rounded-lg transition-all duration-300 flex items-center justify-center'>
                      <div className='opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex space-x-2'>
                        <button
                          onClick={e => {
                            e.stopPropagation()
                            setImagePreview({
                              isOpen: true,
                              imageUrl: imageUrl,
                              imageName:
                                attachment.originalName || `Image ${index + 1}`
                            })
                          }}
                          className='p-2 bg-black/50 rounded-full hover:bg-black/70 transition-colors'
                          title='View full size'
                        >
                          <Eye className='w-4 h-4 text-white' />
                        </button>
                        <button
                          onClick={async e => {
                            e.stopPropagation()
                            try {
                              const response = await fetch(imageUrl)
                              const blob = await response.blob()
                              const url = window.URL.createObjectURL(blob)
                              const link = document.createElement('a')
                              link.href = url
                              link.download =
                                attachment.originalName || 'download'
                              document.body.appendChild(link)
                              link.click()
                              document.body.removeChild(link)
                              window.URL.revokeObjectURL(url)
                            } catch (error) {
                              console.error('Download failed:', error)
                            }
                          }}
                          className='p-2 bg-black/50 rounded-full hover:bg-black/70 transition-colors'
                          title='Download'
                        >
                          <Download className='w-4 h-4 text-white' />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className='absolute bottom-2 left-2 bg-black/60 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                    {attachment.originalName || 'Attachment'}
                  </div>
                </div>
              )
            })}
            {message.content && (
              <p className='text-sm mt-2 break-words'>{message.content}</p>
            )}
          </div>
        )

      case 'file':
        return (
          <div className='space-y-2'>
            {message.attachments?.map((attachment, index) => (
              <div
                key={index}
                className='flex items-center space-x-3 p-3 bg-slate-700/30 rounded-lg hover:bg-slate-700/50 transition-colors'
              >
                <FileText className='w-8 h-8 text-teal-400 flex-shrink-0' />
                <div className='flex-1 min-w-0'>
                  <p className='font-medium truncate'>
                    {attachment.originalName}
                  </p>
                  <p className='text-xs text-slate-400'>
                    {attachment.size && (attachment.size / 1024).toFixed(1)} KB
                  </p>
                </div>
                <button
                  onClick={async () => {
                    try {
                      const fileUrl = `${(
                        process.env.REACT_APP_BACKEND_URL ||
                        'http://localhost:5000/api'
                      ).replace(/\/api\/?$/, '')}${attachment.filePath}`
                      const response = await fetch(fileUrl)
                      const blob = await response.blob()
                      const url = window.URL.createObjectURL(blob)
                      const link = document.createElement('a')
                      link.href = url
                      link.download = attachment.originalName || 'download'
                      document.body.appendChild(link)
                      link.click()
                      document.body.removeChild(link)
                      window.URL.revokeObjectURL(url)
                    } catch (error) {
                      console.error('Download failed:', error)
                    }
                  }}
                  className='p-2 hover:bg-slate-600/50 rounded-full transition-colors'
                >
                  <Download className='w-4 h-4' />
                </button>
              </div>
            ))}
            {message.content && (
              <p className='text-sm mt-2'>{message.content}</p>
            )}
          </div>
        )

      case 'forward':
        return (
          <div className='border-l-4 border-teal-400/50 pl-3'>
            <p className='text-xs text-slate-400 mb-2 flex items-center'>
              <Forward className='w-3 h-3 mr-1' />
              Forwarded message
            </p>
            <p className='text-sm whitespace-pre-wrap break-words'>
              {message.content}
            </p>
          </div>
        )

      default:
        return (
          <p className='text-sm whitespace-pre-wrap break-words'>
            {message.content}
          </p>
        )
    }
  }

  return (
    <div
      className={`flex ${isFromCurrentUser ? 'justify-end' : 'justify-start'}`}
    >
      <div
        className={`max-w-xs lg:max-w-md relative group ${
          isFromCurrentUser ? 'order-2' : 'order-1'
        }`}
        onMouseEnter={() => setShowActions(true)}
        onMouseLeave={() => setShowActions(false)}
      >
        <div
          className={`relative p-4 rounded-2xl shadow-lg transition-all duration-300 hover:shadow-xl ${
            isFromCurrentUser
              ? 'bg-gradient-to-br from-teal-500 to-teal-600 text-white ml-4 rounded-br-md'
              : 'bg-gradient-to-br from-slate-700 to-slate-800 text-teal-100 mr-4 rounded-bl-md'
          } ${message.isPinned ? 'ring-2 ring-yellow-400/50' : ''}`}
        >
          {message.isPinned && (
            <div className='absolute -top-2 -right-2'>
              <div className='bg-yellow-400 text-slate-900 rounded-full p-1'>
                <Pin className='w-3 h-3' />
              </div>
            </div>
          )}

          {renderMessageContent()}

          <div
            className={`flex items-center justify-between mt-2 text-xs ${
              isFromCurrentUser ? 'text-teal-100' : 'text-slate-400'
            }`}
          >
            <span>{formatTime(message.sentAt)}</span>
            {getMessageStatusIcon()}
          </div>
        </div>

        {/* Message Actions */}
        {showActions && (
          <div
            className={`absolute top-0 ${
              isFromCurrentUser
                ? 'left-0 -translate-x-full'
                : 'right-0 translate-x-full'
            } flex space-x-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300`}
          >
            <button
              onClick={() => onMessageAction('pin', message._id)}
              className='p-2 bg-slate-700 hover:bg-slate-600 rounded-full shadow-lg transition-colors'
              title='Pin message'
            >
              <Pin className='w-3 h-3' />
            </button>
            <button
              onClick={() => onMessageAction('forward', message._id)}
              className='p-2 bg-slate-700 hover:bg-slate-600 rounded-full shadow-lg transition-colors'
              title='Forward message'
            >
              <Forward className='w-3 h-3' />
            </button>
            <button
              onClick={() => onMessageAction('delete', message._id)}
              className='p-2 bg-red-600 hover:bg-red-500 rounded-full shadow-lg transition-colors'
              title='Delete message'
            >
              <Trash2 className='w-3 h-3' />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

// Search Results Component
const SearchResults = ({ results, onResultClick }) => {
  return (
    <div className='p-4 space-y-3'>
      <h3 className='text-sm font-semibold text-slate-400 mb-3'>
        Search Results
      </h3>
      {results.map((result, index) => (
        <div
          key={index}
          onClick={() => onResultClick(result.conversationId)}
          className='p-3 hover:bg-slate-700/30 rounded-xl cursor-pointer transition-all duration-300'
        >
          <div className='flex items-center space-x-3'>
            <div className='w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center text-white font-bold'>
              {result.conversationName?.charAt(0).toUpperCase()}
            </div>
            <div className='flex-1 min-w-0'>
              <p className='font-medium text-teal-300 truncate'>
                {result.conversationName}
              </p>
              <p className='text-sm text-slate-400 truncate'>
                {result.messageContent}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

// Empty State Component
const EmptyState = () => {
  return (
    <div className='flex items-center justify-center h-full'>
      <div className='text-center'>
        <div className='w-24 h-24 bg-gradient-to-br from-teal-500/20 to-teal-600/20 rounded-full flex items-center justify-center mx-auto mb-6'>
          <MessageSquare className='w-12 h-12 text-teal-400' />
        </div>
        <h2 className='text-2xl font-bold text-teal-300 mb-3'>
          Welcome to Messages
        </h2>
        <p className='text-slate-400 max-w-md'>
          Select a conversation to start chatting, or create a new one to
          connect with someone.
        </p>
        <div className='mt-8 space-y-2'>
          <div className='flex items-center justify-center space-x-2 text-sm text-slate-500'>
            <div className='w-2 h-2 bg-teal-500 rounded-full animate-pulse'></div>
            <span>Real-time messaging</span>
          </div>
          <div className='flex items-center justify-center space-x-2 text-sm text-slate-500'>
            <div className='w-2 h-2 bg-teal-500 rounded-full animate-pulse delay-100'></div>
            <span>File sharing</span>
          </div>
          <div className='flex items-center justify-center space-x-2 text-sm text-slate-500'>
            <div className='w-2 h-2 bg-teal-500 rounded-full animate-pulse delay-200'></div>
            <span>Group conversations</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MessagingApp
